import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-5 rounded-full bg-primary-500" />
            <h2 className="text-white text-lg font-semibold">分类导航</h2>
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/category' : `/category/${cat.slug}`}
                className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-white/[0.03] hover:bg-white/[0.06] border border-white/5 hover:border-primary-500/30 transition-all duration-300"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-950 transition-all duration-300">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <span className="text-foreground-400 text-xs font-medium group-hover:text-white transition-colors">
                  {cat.name}
                </span>
                <span className="text-foreground-600 text-[10px]">{cat.count}部</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}